import { render } from "./LargeSpinner.vue?vue&type=template&id=55533ac5&scoped=true"
const script = {}

import "./LargeSpinner.vue?vue&type=style&index=0&id=55533ac5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55533ac5"]])

export default __exports__